var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent, cloneElement, isValidElement, Children } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

/**
 * The `IconSeparator` component is a simple helper component to render some text and
 * an icon with some space between them while centering the text. The icon can either
 * come before or after the text.
 */

var IconSeparator = function (_PureComponent) {
  _inherits(IconSeparator, _PureComponent);
  function IconSeparator() {
    _classCallCheck(this, IconSeparator);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  IconSeparator.prototype.render = function render() {
    var _props = this.props,
      className = _props.className,
      labelStyle = _props.labelStyle,
      labelClassName = _props.labelClassName,
      component = _props.component,
      label = _props.label,
      iconBefore = _props.iconBefore,
      children = _props.children,
      props = _objectWithoutProperties(_props, ['className', 'labelStyle', 'labelClassName', 'component', 'label', 'iconBefore', 'children']);
    var text = void 0;
    if (isValidElement(label)) {
      var labelProps = Children.only(label).props;
      text = cloneElement(label, {
        className: cn('md-icon-text', labelClassName, labelProps.className),
        style: _extends({}, labelStyle, labelProps.style)
      });
    } else {
      text = React.createElement('span', {
        style: labelStyle,
        className: cn('md-icon-text', labelClassName)
      }, label);
    }
    var Component = component;
    return React.createElement(Component, _extends({}, props, {
      className: cn('md-icon-separator', className)
    }), iconBefore && children, text, !iconBefore && children);
  };
  return IconSeparator;
}(PureComponent);
IconSeparator.propTypes = {
  /**
   * An optional style to apply.
   */
  style: PropTypes.object,
  /**
   * An optional className to apply.
   */
  className: PropTypes.string,
  /**
   * An optional style to apply to the label.
   */
  labelStyle: PropTypes.object,
  /**
   * An optional className to apply to the label.
   */
  labelClassName: PropTypes.string,
  /**
   * The label to display.
   */
  label: PropTypes.node.isRequired,
  /**
   * The icon to display.
   */
  children: PropTypes.node.isRequired,
  /**
   * Boolean if the icon should appear before or after the text
   */
  iconBefore: PropTypes.bool,
  /**
   * The component to be rendered as.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]).isRequired
};
IconSeparator.defaultProps = {
  component: 'div'
};
export default IconSeparator;